<template>
  <div class="Message xi">
    <nh-com></nh-com>
    <div class="personal-content">
      <div class="personal-box clearfix">
        <div class="personal-left">
          <hd-img></hd-img>
        </div>
        <div class="personal-right">
          <div class="top1" style="min-height: 800px;">
            <div class="flex-start">
              <p style="margin-right: 10px; font-size: 16px">团队分账金额</p>
            </div>
            <div class="" style="background: linear-gradient(180deg, #FFF9F0, #FFFFFF);border-radius: 4px;border: 2px solid #FFEFDB; padding: 20px 50px;padding-right:160px ; display: flex;align-items: center;justify-content: space-between;margin-left: 20px;margin-top: 30px;">
              <div class="top1-2">
                    <div>
                      <img src="../../assets/img/yue.png" style="width: 28px;height: 28px;margin-right: 10px;vertical-align: sub;" alt="">
                      <span>当前可分金额(元)</span>
                      <span class="t-desc" style="margin-left:30px;margin-right: 10px;">￥</span>
                      <span class="num" style="color: #F54B20;font-weight: bold;">{{ UserBalance.commanderAssetsTotalBalance>0?UserBalance.commanderAssetsTotalBalance.toFixed(2):'0' }}</span>
                      <span class="t-desc" style="margin-left:10px;">元</span>
                    </div>
                  </div>
                  <div class="top1-3">
                    <div >
                      <span>当前金额分账方式：</span> <span class="" style="margin-left: 5px;color: #F54B20;">团队平均分账</span>
                    </div>
                  </div>
            </div>
            <div  style="width: 620px;margin: auto;  margin-top: 80px;" >
              <!-- 分账金额输入行 -->
              <div class="split-input-row">
                <label class="split-label">分账金额</label>
                <div class="input-wrap">
                  <el-input placeholder="请输入分账金额" v-model="shareForm.inputShareMoney"   @input="onKeyInput" style="width: 430px;"></el-input>
                </div>
                <span class="all-money-btn" @click="allMoney">全部金额</span>
              </div>
              <!-- 团队人均浅色卡片 -->
              <div class="info-card">
                <div class="info-line">
                  <span class="info-key">团队人数</span>
                  <span class="info-value">{{UserBalance.commanderTeamCount}}人</span>
                </div>
                <div class="info-line">
                  <span class="info-key">成员人均</span>
                  <span class="info-value">¥{{shareForm.personalMoney || ''}}</span>
                </div>
                <div class="info-line">
                  <span class="info-key">实际分账金额</span>
                  <span class="info-value">¥{{shareForm.publicShareMoney || '' }}</span>
                </div>
              </div>
              <!-- 底部按钮 -->
              <div slot="footer" class="split-footer">
                <!-- <el-button size="large" @click="goBack">取消</el-button>
                <el-button v-if="UserBalance.availableBalance> 0 && shareForm.publicShareMoney>0" type="warning" size="large" @click="confirmBtn">确认分账</el-button>
                <el-button v-else type="warning" size="large" style="opacity: 0.6;" >确认分账</el-button> -->
                  <button class="btn-cancel" @click="goBack">取消</button>
                  <button v-if="UserBalance.commanderAssetsTotalBalance> 0 && shareForm.publicShareMoney>0" class="btn-submit"  :disabled="isSubmitting" @click="confirmBtn">确认分账</button>
                  <button v-else class="btn-submit" style="opacity: 0.6;">确认分账</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ft-com></ft-com>
  </div>
</template>
<script>
import { shoppingMall } from "../../components/shoppingMall/shoppingMall";
// import { shoppingMall } from '../../components/shoppingMall/shoppingMall';
import ftCom from "../../components/footer";
import nhCom from "../../components/navheader";
import hdImg from "../../components/headerImg";
import { UserInfo } from "../../components/User/UserInfo";
var pageIndex = 1;
var keywordVal = "";
var myDate = new Date();
export default {
  name: "Message",
  components: {
    ftCom,
    nhCom,
    hdImg,
  },
  data() {
    var shoppingMalltem = new shoppingMall(this.TokenClient, this.Services.shoppingMall);
    var UserDistributorltem = new shoppingMall(this.TokenClient, this.Services.Authorization);
    var UserDistributorltemdrug = new shoppingMall(this.TokenClient, this.Services.Drug);
    var user = new UserInfo(this.TokenClient, this.Services.Authorization);

    return {
      userDomain: user,
      UserBalance: {
        assetsBalance: 0,
      },
      shareForm: {
        inputShareMoney: '',
        personalMoney: 0,
        publicShareMoney: 0,
      },
      labelPosition: "right",
      MessageList: [],
      MessageDetail: {},
      total: 0,
      currentPage: 1, //初始页
      keyword: "",
      PageTotal: 1,
      MessageTotal: 0,
      rloading: [], //loading遮罩
      shoppingMallMain: shoppingMalltem,
      UserDistributorMain: UserDistributorltem,
      UserDistributorMaindrug: UserDistributorltemdrug,
      dialogVisible: false,
      RegionData: [],
      UserBalanceTable: [],
      type: "0",
      pageIndex: 1,
      valueDate: "",
      auditTotal: 0,
      appdialogVisible: false,
      chargedialogVisible: false,
      userInfo: this.$store.state.localData.userInfo,
      isSubmitting: false, // 分账提交锁
    };
  },
  mounted() {
    this.AllMessages();
  },
  methods: {
    goBack(){
      this.$router.go(-1)
    },
    		confirmBtn() {
           if (this.isSubmitting) return
				if(this.shareForm.publicShareMoney>this.UserBalance.commanderAssetsTotalBalance){
          this.$message({
            message: '实际分账金额超出最高可分账金额！',
            type: 'warning'
          })
					return
				}
        this.isSubmitting = true
        var _this = this
        _this.UserDistributorMain.BatchCommanderBalanceTransfer(
          _this.shareForm.personalMoney.toFixed(2),
          function (data) {
                // 成功解锁
              _this.isSubmitting = false
              _this.$message({
                message: '分账成功！',
                type: 'success'
              })
							_this.shareForm={
								inputShareMoney: '',
								personalMoney: 0,
								publicShareMoney: 0,
							}
							_this.AllMessages()
          },
          function (err) {
             // 失败也要解锁
            _this.isSubmitting = false
            _this.UserBalance = [];
            console.log(err);
          }
        );
			},
    onKeyInput(val) {
      // element el-input @input 直接传当前值，不需要event.target.value
      let inputVal = val;

      // 1. 只允许数字和小数点
      inputVal = inputVal.replace(/[^\d.]/g, '');

      // 2. 防止多个小数点
      const dotIdx = inputVal.indexOf('.');
      if (dotIdx !== -1) {
        const beforeDot = inputVal.substring(0, dotIdx + 1);
        const afterDot = inputVal.substring(dotIdx + 1).replace(/\./g, '');
        inputVal = beforeDot + afterDot;
      }

      // 3. 限制最多两位小数
      if (inputVal.includes('.')) {
        const [intPart, decPart] = inputVal.split('.');
        if (decPart.length > 2) {
          inputVal = `${intPart}.${decPart.substring(0, 2)}`;
        }
      }

      // 4. 判断是否超过可用余额
      const numVal = Number(inputVal || 0)
      if(numVal > this.UserBalance.commanderAssetsTotalBalance) {
          this.shareForm.inputShareMoney = ''
          this.$message({
            message: '超出最大分账金额！',
            type: 'warning'
          })
          return
      }

      // 赋值回表单双向绑定
      this.shareForm.inputShareMoney = inputVal;

      // 计算人均金额（保留2位小数）
      let personalMoney = Number(numVal);
      if (inputVal && !isNaN(numVal)) {
        personalMoney = (Number(numVal) == 0.01 ? 0.01 : numVal  / this.UserBalance.commanderTeamCount).toFixed(2);
        personalMoney = parseFloat(personalMoney);
      }

      // 总金额回填校验
      let publicShareMoney = 0;
      if (personalMoney > 0) {
        publicShareMoney = (personalMoney * this.UserBalance.commanderTeamCount).toFixed(2);
        publicShareMoney = parseFloat(publicShareMoney);
      }

      this.shareForm.personalMoney = personalMoney
      this.shareForm.publicShareMoney = publicShareMoney
    },
    allMoney() {
      let personalMoney = 0;
      this.shareForm.inputShareMoney = this.UserBalance.commanderAssetsTotalBalance
      if (this.shareForm.inputShareMoney && !isNaN(this.shareForm.inputShareMoney)) {
        personalMoney = parseFloat(this.shareForm.inputShareMoney) / this.UserBalance.commanderTeamCount;
        personalMoney = parseFloat(personalMoney.toFixed(2)); // 保留两位小数并转为数字
      }
      // 计算公共金额并保留两位小数
      let publicShareMoney = 0;
      if (personalMoney > 0) {
        publicShareMoney = personalMoney * this.UserBalance.commanderTeamCount;
        console.log(publicShareMoney)
        publicShareMoney = parseFloat(publicShareMoney.toFixed(2)); // 保留两位小数并转为数字
      }
      this.shareForm.personalMoney = personalMoney
      this.shareForm.publicShareMoney=publicShareMoney
    },
    //分页点击事件
    handleCurrentChange: function (pageNum) {
      this.currentPage = pageNum;
      pageIndex = pageNum;
      this.getAssetsDetailsListime();
    },
    AllMessages() {
      var _this = this;
      _this.UserDistributorMain.getCommanderAssetsDetails(
        function (data) {
          _this.UserBalance = data.data;
        },
        function (err) {
          _this.UserBalance = [];
          console.log(err);
        }
      );
    }
  },
};
</script>

<style scoped>
@import "../../assets/css/footer.css";

#page {
  text-align: center;
  padding: 100px 0 30px;
}
.imgBox {
  display: flex;
  justify-content: space-between;
  margin: 0 60px;
}
.imgBoxurl {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.imgBoxurl1 {
  width: 180px;
  height: 180px;
}
.pageBox {
  text-align: center;
  margin-top: 5px;
}
.top2 {
  padding: 25px 30px;
  background: #fff;
}
.recordtitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
}
.boxtagCheck {
  padding: 0 20px;
  background: linear-gradient(90deg, #00c4ac, #5bd2c3);
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
.pointer{
  cursor: pointer;
}
.boxtag {
  cursor: pointer;
  padding: 0 20px;
  background-color: #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
}
.banner {
  width: 100%;
  height: 160px;
  background: url("../../assets/img/news_banner.jpg") center no-repeat;
}

.banner-wrap {
  position: relative;
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}

.banner-text {
  float: left;
}

.banner-text h3 {
  padding-top: 35px;
  font-size: 26px;
  font-weight: normal;
  color: #ffffff;
}

.banner-text p {
  font-size: 14px;
  color: #ffffff;
  margin-top: 20px;
}
.centercontentMoney {
  margin: 20px;
  background: #f5f5f5;
  padding: 20px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.centercontentMoney1 {
  width: calc(100% - 300px);
  display: flex;
  justify-content: space-around;
  align-items: baseline;
}
.centercontentMoney2 {
  width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.centercontentMoney1i {
  font-size: 42px;
}
.centercontentMoney1Money {
  font-size: 48px;
  color: #00afb5;
}
.center-content {
  margin: 10px 0;
}
.banner-text p a {
  color: #ffffff;
  font-size: 14px;
  margin: 0 5px;
}

/**/
.personal-content {
  background: #f7f7f7;
  padding: 40px 0;
}

.personal-box {
  width: 1200px;
  margin: 0 auto;
}

.personal-left {
  float: left;
}

.personal-right {
  float: right;
  width: 985px;
  min-height: 740px;
  /* background: #ffffff; */
  box-sizing: border-box;
}

.personal-right-tit {
  border-bottom: 1px solid #e5e5e5;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.personal-right-tit .iconfont {
  color: #04a290;
  font-size: 24px;
  margin-right: 5px;
}

.personal-right-tit span {
  display: inline-block;
  font-size: 24px;
  font-weight: 700;
  color: #333333;
}

.personal-right-tit span em {
  font-style: normal;
  color: #04a290;
}

.personal-right-tit .el-icon-delete {
  float: right;
  font-size: 18px;
}

.msg-list {
  padding: 0 20px;
}

.msg-list .msg-item {
  padding: 8px 0;
  border-bottom: 1px dashed #e5e5e5;
  line-height: 40px;
  height: 40px;
}

.msg-list .msg-item h4 {
  color: #999999;
  font-weight: normal;
  width: 700px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.msg-list .msg-item.noread h4 {
  color: #333333;
}

.msg-list .msg-item p {
  color: #999999;
}

.msg-detail {
  padding: 20px;
  display: none;
}

.msg-detail .mess-tit {
  text-align: center;
}

.msg-detail .mess-info p {
  text-indent: 28px;
}
.mess-info .item-img {
  margin-right: 10px;
  display: flex;
  justify-content: flex-start;
  justify-items: center;
  flex-wrap: wrap;
}
.item-img img {
  width: 118px;
  height: 118px;
}
</style>
<style scoped lang="scss">
.top1 {
  padding: 20px 15px;
  color: #000;
  background: #ffffff;
  border-radius: 8px;
  .line-1 {
    width: 1px;
    height: 70px;
    background: #b9b9b9;
  }
  .right-t {
    margin-left: 10px;
  }
  .top1-1-1 {
    font-weight: bold;
    font-size: 18px;
    color: #333333;
    margin-right: 10px;
  }
  .top1-1-2 {
    background: #ffffff;
    border-radius: 10px;
    border: 1px solid #b5d5d0;
    padding: 0 10px;
  }
  .top1-1-3 {
    color: #333;
  }
  .num {
    font-size: 25px;
    font-weight: bold;
  }
  .t-desc {
    font-size: 14px;
    font-weight: bold;
  }
  .btn1 {
    background: linear-gradient(90deg, #ff793b, #ff9d70);
    border-radius: 4px;
    color: #fff;
    padding: 0 20px;
    cursor: pointer;
  }
  .btn2 {
    background: linear-gradient(90deg, #ff9c27, #ffc36f);
    border-radius: 4px;
    color: #fff;
    padding: 0 20px;
    cursor: pointer;
  }
  .btn3 {
    background: linear-gradient(90deg, #00c4ac, #5bd2c3);
    border-radius: 4px;
    color: #fff;
    padding: 0 20px;
    cursor: pointer;
  }
  .total {
    font-size: 14px;
    color: #ff405e;
  }
}
/* 输入整行布局 */
.split-input-row {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
}
.split-label {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  white-space: nowrap;
}
.input-wrap {
  display: flex;
  align-items: center;
}
.yuan {
  font-size: 20px;
  color: #666;
  margin-right: 8px;
}
.all-money-btn {
  font-size: 16px;
  cursor: pointer;
  white-space: nowrap;
  color: #F54B20;
}

/* 人均信息浅橙卡片 */
.info-card {
  background-color: #fff3eb;
  border-radius: 6px;
  padding: 21px 20px;
  margin-bottom: 50px;
  width: 400px;
  margin: auto;
}
.info-line {
  display: flex;
  justify-content: space-between;
  line-height: 2.2;
  font-size: 20px;
}
.info-key {
  color: #333;
  font-size: 16px;
}
.info-value {
  color: #ff4220;
  font-weight: Bold;
  font-size: 16px;
}

/* 底部按钮居中 */
.split-footer {
  margin-top: 80px;
  display: flex;
  justify-content: center;
  gap: 24px;
}
.split-footer .el-button {
  width: 210px;
  height: 40px;
  font-size: 16px;
}
.btn-bottom-wrap {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-top: 50px;
}
.btn-cancel {
  width: 210px;
  height: 40px;
  border: 1px solid #cccccc;
  background: #ffffff;
  border-radius: 4px;
  font-size: 16px;
  color: #333333;
  cursor: pointer;
  transition: all 0.2s;
}
.btn-cancel:hover {
  border-color: #999;
}
.btn-submit {
  width: 210px;
  height: 40px;
  border: none;
  border-radius: 4px;
  background: linear-gradient(90deg, #ff782e, #ffab78);
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
  transition: opacity 0.2s;
}
.btn-submit:hover {
  opacity: 0.9;
}
</style>
